import { render, staticRenderFns } from "./sentioComponent.vue?vue&type=template&id=17db8eca&"
import script from "./sentioComponent.vue?vue&type=script&lang=js&"
export * from "./sentioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports